<!-- src/views/HomePage.vue -->
<template>
     <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;aspect-ratio: 220/100;     ">
      <div class="c-text-between c-flex-1" style="position: relative;">
        <div class="title-width c-text-column" style="align-items: flex-start; justify-content: center;z-index: 2;">
          <span style="color: #587380;font-size: 12px;">赋予AI机器人躯体</span>
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">专为前沿科研打造的高端机器人系统</h1>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka Robotics提供专为尖端研究量身定制的高科技机器人系统，集卓越机电一体化技术、强大软件生态与多功能扩展套件于一体，可无缝兼容第三方配件，助力各类创新应用场景的实现。</span>
        </div>   
          <img src="@/assets/images/productsPage/V2 Desktop.jpg" alt="" 
          
            style="    height: 100%;width: 100%;position: absolute;"> 
        <div class="c-flex-1 c-text-both">  
        </div> 
      </div> 
      </div>
      
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">产品
        </span>
        <hr class="divider">
      </div> 
       <div class="c-text-between px-container  c-flex-wrap c-font-14" style="margin-bottom: 120px;">
      <div class="action-width c-text-column c-mb-60">
        <div class="c-mb-5" style="overflow: hidden;">
          <!-- 4b260ce4e6024b3d8814757eb1e1580.jpg -->
          <img src="@/assets/images/productsPage/_Frank Robotics4386_resized-1.jpg" alt="" class="image-style"
            style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight c-mb-10 c-mt-5">Franka Research 3（FR3）</div>
        <div class="c-text-left ">Franka Research 3 是一款世界级的参考级力敏机器人系统，专为机器人与人工智能研究而定制。它为研究人员提供了易于使用的机器人功能，同时也提供了对机器人控制和学习能力的底层访问。
        </div>
        <div class="c-text-left c-mt-10">
          <a @click="$router.push('/products/franka-research-3')" class="linkTag" target="_blank">
            了解 FR3
          </a>
        </div>

      </div>
      <div class="action-width c-text-column c-mb-60 ">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/251105_MFR3_Duo_Camera01_01_fp.png" class="image-style" alt=""
            style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight c-mb-10 c-mt-5">FR3 Duo 与移动式 FR3 Duo</div>
        <div class="c-text-left ">FR3 Duo 将两台 FR3 机械臂组合成一个即用型的双臂机器人系统，用于操作、模仿学习和遥操作等研究。其移动版本基于相同的架构，安装在一个紧凑的底座上，底座配备了机载计算单元、传感器和摄像头。
        </div>
        <div class="c-text-left c-mt-10">
          <a  @click="$router.push('/product-prototypes')" class="linkTag" target="_blank">
            了解（移动式）FR3 Duo</a>
        </div>
      </div>
      <div class="action-width c-text-column c-mb-60">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/201009_V2_P4_duerr_cut.jpg" class="image-style"
            alt="" style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight c-mb-10 c-mt-5">思灵机器人 Diana 7</div>
        <div class="c-text-left ">
         M思灵机器人推出的力敏机器人 Diana 7 以其 7 个轴、7 千克的有效负载和高精度脱颖而出。现在，通过集成 Franka 控制接口（FCI），用户可以访问控制回路并以 1 kHz 的频率从传感器捕获系统状态数据，这使得 Diana 7 同样非常适合研究用途。
        </div>
        <div class="c-text-left c-mt-10">
          <a   @click="$router.push('/products/diana-7')" class="linkTag" target="_blank">
            了解 Diana 7</a>
            
        </div>
      </div>
    </div>
    
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">组件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>探索第三方配件</h1>
        
          <div class="c-text-justify-start c-flex-wrap c-mt-20 c-mb-10"> 
            <div class="buttonSite">
              <!-- documents -->
              <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
              <a  @click="$router.push('/accessories')"  target="_self">获取更多</a>
            </div>
          </div>  
        </div>
        <div class="display-width">
          <img src="@/assets/images/productsPage/Murrplastik_01 (1).jpg" alt=""
            style="    height: auto; max-width: 100%;">
        </div>
      </div>
      <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">社区共创成果</span>
        <hr class="divider">
      </div>
      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
          <div class="display-width">
            <img src="@/assets/images/productsPage/_Frank Robotics0615_resized-1.jpg" alt=""
              style="    height: auto; max-width: 100%;">
          </div>  
          <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;"> 
            <div class="c-flex-1 c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;z-index: 2;">
              <span style="color: #587380;font-size: 12px;">探索·加入·共创</span>
              <h2 style="font-size: 28px;font-family: 'Montserrat', sans-serif;text-align: left;">领略Franka社区的卓越智慧结晶</h2>
            
              <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka社区以机器人学与人工智能领域的创新协作精神闻名。这里汇聚了众多标杆级开源成果，展现顶尖科研社群的非凡创造力！</span>
              <div class="c-text-justify-start c-flex-wrap"> 
                  <router-link to="/contact" class="buttonSite">联系我们</router-link> 
              </div>
            </div>    
             
          </div>    
      </div>  
      
      <!-- <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
        <div class="action-width c-text-column" style="border: 1px solid #80808061;padding: 10px;margin-bottom: 10px;"> 
            <div class="c-mb-5" style="overflow: hidden;">
              <img src="@/assets/images/productsPage/desk.470b822.png" alt=""  class="image-style" style="height: auto; max-width: 100%;">
            </div>
            <div style="align-items: flex-start;text-align: left;" class=" c-text-column " > 
              <h1>DESK</h1> 
              <span class="c-mt-5 c-mb-5 text-indent" > 
                Desk让编程变得省时省力，是快速原型开发、简单人机交互研究和演示的最佳用户界面。
              </span>  
              <div class="linkTag"> 
                <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
              </div> 
            </div>
        </div> 
        <div class="action-width c-text-column " style="border: 1px solid #80808061;padding: 10px;margin-bottom: 10px;"> 
            <div class="c-mb-5" style="overflow: hidden;">
              <img src="@/assets/images/productsPage/ride.a041de5.png" class="image-style" alt="" style="height: auto; max-width: 100%;">
            </div>
            
            <div style="align-items: flex-start;text-align: left;" class=" c-text-column " > 
              <h1>RIDE </h1> 
              <span class="c-mt-5 c-mb-5 text-indent" style="overflow: hidden;" > 
                RIDE使研究人员能够将Franka Robotics系统完全集成到实验设置中，充分利用其高性能的集成控制器。
                它也是教学入门级机器人技术的优秀工具，提供了一个用户友好的界面，便于学习和实验。
              </span>  
              <div class="linkTag">
                <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
              </div> 
            </div> 
        </div> 
        <div class="action-width c-text-column" style="border: 1px solid #80808061;padding: 10px;margin-bottom: 10px;"> 
            <div class="c-mb-5">
              <img src="@/assets/images/productsPage/fci.7cc017e.png" alt="" class="image-style" style=" height: auto; max-width: 100%;">
            </div>  
            <div style="align-items: flex-start;text-align: left;" class=" c-text-column " > 
              <h1>FCI </h1> 
              <span class="c-mt-5 c-mb-5 text-indent" > 
                FCI绕过机器人的控制系统，使研究人员能够在外部实时计算机上以1 kHz的频率运行自定义控制算法。它是探索底层规划和控制方案的理想接口。
              </span>  
              <div class="linkTag">
                <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
              </div> 
            </div>
        </div> 
      </div> 
      <div class=" px-container"  style="margin-bottom: 120px;"> 
        <table >
          <thead>
            <tr>
              <th>功能</th>
              <th>DESK</th>
              <th>RIDE</th>
              <th>FCI</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="index">
              <td>{{ row.name }}</td>
              <td>
                <span v-if="row.DESK">
                  <div  class="c-text-both">
                    <div style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;"></div>
                  </div>
                </span> 
                <span v-else></span>
              </td>
              <td>
                <span v-if="row.RIDE">
                  <div  class="c-text-both">
                    <div style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;"></div>
                  </div>
                </span> 
                <span v-else></span>
              </td>
              <td>
                <span v-if="row.FCI">
                  <div  class="c-text-both">
                    <div style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;"></div>
                  </div>
                </span> 
                <span v-else></span> 
              </td>
            </tr>
          </tbody>
        </table> 
      </div> -->
 
      <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">对我们的产品感兴趣吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2">
                <!-- <div class="buttonSite"> -->
                  <router-link to="/contact" class="buttonSite">联系我们</router-link>
                <!-- </div> -->
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div>
          <!-- <div class="display-width">
            <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: auto; max-width: 100%;">
          </div> --> 
  </template>
  
  <script>
  
import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'HomePage',
    data(){
      return{
        iframe1:'2',
        iframe2:'2',
        backgroundImage:backgroundImage,
        tableData: [
          { name: '基于工作流的应用程序编程',DESK:true,RIDE:false,FCI:false},
          { name: '快速原型设计实验和演示 ', DESK:true,RIDE:false,FCI:false},
          { name: '执行机器人任务', DESK:true,RIDE:false,FCI:true},
          { name: '开发自定义应用程序', DESK:false,RIDE:true,FCI:false},
          { name: '连接第三方硬件', DESK:false,RIDE:true,FCI:true},
          { name: '连接外部资源',DESK:false,RIDE:true,FCI:true },
          { name: '1 kHz 力矩、位置和速度控制 ', DESK:false,RIDE:false,FCI:true},
          { name: '1 kHz 传感器信号和机器人状态的测量', DESK:false,RIDE:false,FCI:true},
          { name: '访问机器人运动学和动力学模型', DESK:false,RIDE:false,FCI:true},
          { name: '与ROS和MATLAB & Simulink的集成', DESK:false,RIDE:false,FCI:true},
        ]
      }

    },
  };
  </script>
<style scoped> 
  .display-width{
    width: calc(50% - 40px);
  }
    /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  .title-width{
    width: 33.33%;
  }
    /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .title-width{
      width: 100%
    }
  } 
.action-height{
  height: 400px;
  background-color: #d5dbdc; 
  position: relative;
}
.action-width{
  width: calc(33% - 40px);
}
/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width{
    width: calc(50% - 40px);
  }
  .action-height{
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width{
    width: 100%;
  }
}
table {
    width: 100%; 
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid black;
    padding: 5px;
    text-align: left;
  } 

</style>
  